export default "__VITE_ASSET__DCKmuItX__"